// src/Component/former/Former.js
import React from 'react';
import { Helmet } from 'react-helmet'; // Import Helmet for SEO
import './coater.css'; // Import the CSS for styling

import bar1 from '../../image/bar1.png';
import bar2 from '../../image/bar2.png';

const Coater = () => {
  return (
    <div className="details-container">

      {/* SEO Meta Tags */}
      <Helmet>
        <title>Bar Coater V2 & V3 - Bar Coating Machine Units in India</title>
        <meta
          name="description"
          content="Bar Coater V2 & V3 - Bar Coating Machine Units in India. P. Rakesh Industries offers advanced Mayer Bar Coaters, Rod Coaters, and Bar Coater Machines including Bar Coater V2 and V3 models for precise coating applications. Our paper barrier coating machines and offline coating stations in India ensure uniform coating quality, durability, and efficient performance for various paper and board applications."
        />
        <meta property="og:title" content="Bar Coater V2 & V3 - Bar Coating Machine Units in India" />
        <meta
          property="og:description"
          content="Bar Coater V2 & V3 - Bar Coating Machine Units in India. P. Rakesh Industries offers advanced Mayer Bar Coaters, Rod Coaters, and Bar Coater Machines including Bar Coater V2 and V3 models for precise coating applications. Our paper barrier coating machines and offline coating stations in India ensure uniform coating quality, durability, and efficient performance for various paper and board applications."
        />
        <meta property="og:url" content="https://pripapermachines.com/bar-coater-v2-v3-bar-coating-machine-units-in-india" />
        <link rel="canonical" href="https://pripapermachines.com/bar-coater-v2-v3-bar-coating-machine-units-in-india" />
      </Helmet>

      <div className="details-content">
        {/* Left Column */}
        <div className="column left">
          <div>
            <h1 style={{color:"#4d7544"}}>BAR COATER V2</h1>
            <img src={bar2} alt="Bar Coater V2 & V3" />
            <h1 style={{color:"#4d7544"}}>BAR COATER V3</h1>
            <img src={bar1} alt="Bar Coater V2 & V3" />
          </div>
        </div>

        {/* Right Column */}
        <div className="column right">
          <div className="column-right">
            <p
              style={{
                backgroundColor: "#4d7544",
                borderRadius: "10px",
                color: "white",
                paddingLeft: "20px",
                paddingBottom: "20px",
                paddingRight: "20px",
                paddingTop: "20px",
                width: "100%",
                boxSizing: "border-box",
                textAlign:"left"
              }}
            >
              <span className="dot"></span> Bar coating is a competent technology for applying coating to the board. PRI bar coaters can be used to apply coating to both the top surface and the bottom surface with excellent coating coverage. Pigmented and non-pigmented types of coating are also possible on bar coater.<br /><br />
              <h3>PRI offer coaters in two models</h3>
              &nbsp;&nbsp;&nbsp;&nbsp; Barcoater-Horizontal Lead (Model V2)<br />
              &nbsp;&nbsp;&nbsp;&nbsp; Barcoater-Vertical Lead (Model V3)<br /><br />
              <span className="dot"></span> In a horizontal lead coater, the coating solution is applied to the applicator roll, and then it goes to the backing roll metering beam system for metering.<br /><br />
              <span className="dot"></span> The vertical lead coater is facilitated by a nip coating arrangement where the solution is applied at the applicator roll and metering is done immediately, which minimizes the dwell time.
            </p>

            <h1 style={{color:"#4d7544",textAlign:"left",fontSize:"26px",marginTop:"20px"}}>Key Features:</h1>
            <ul style={{color:"black",textAlign:"left"}}>
              <li>Rotating metering bar prevents sticking.</li><br />
              <li>Service life is much longer than that of the blade.</li><br />
              <li>Rapid connecting coupling between motor and metering bar allows quick changing of the metering bar.</li><br />
              <li>Wear resistance rubber made bar bed with a water flow connection to keep the metering bar clean during operation.</li><br />
              <li>Coat weight can be varied by regulating the air pressure.</li><br />
              <li>The unit is easy to operate and has high functional reliability at constant coat quality.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Coater;
